module.exports = __webpack_public_path__ + "static/assets/0b77433fa2e1b63663d72845e5f07e28.gif";